import * as d3 from 'd3';

/**
 * Implements zoom and pan into the chart.
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

const zoom = (svg: any) => {
  function zoomed(event: any) {
    const transform = event.transform;
    // setGraphTransform(transform); // Saving our current transform, incase of rerenders, implement if necessary
    svg.attr("transform", transform);
  }
  
  return d3.zoom()
      .scaleExtent([1 / 4, 8]) // Defining how much we can zoom the map
      .on("zoom", zoomed);
};

export default zoom;
